import { render } from "./Nav.vue?vue&type=template&id=6f9de822&lang=pug"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"

import "./Nav.vue?vue&type=style&index=0&id=6f9de822&lang=scss"
script.render = render

export default script